<script setup lang="ts">
/**
 * App Footer — shown only on public pages.
 * All styles inline with Tailwind.
 */
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <footer class="bg-[#1a1f2e] text-slate-400 pt-14 px-12 pb-6 max-md:pt-8 max-md:px-4">
    <div class="max-w-[1200px] mx-auto grid grid-cols-[1fr_2fr] gap-12 pb-8 border-b border-white/10 max-lg:grid-cols-1 max-lg:text-center">
      <!-- Brand -->
      <div>
        <div class="flex items-center gap-3 mb-4 max-lg:justify-center">
          <img src="/images/logos/logo-no-text-favicon.png" alt="Code Board" class="w-6 h-6 object-contain">
          <span class="text-white font-semibold">Code Board</span>
        </div>
        <p class="text-sm text-slate-400 leading-relaxed">
          {{ t('footer.description') }}
        </p>
      </div>

      <!-- Links -->
      <div class="grid grid-cols-3 gap-8 max-md:grid-cols-1 max-md:gap-6 max-lg:justify-items-center">
        <div>
          <h4 class="text-sm font-semibold text-white mb-4">{{ t('footer.product') }}</h4>
          <RouterLink to="/pricing" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('nav.pricing') }}</RouterLink>
          <a href="/blog" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('nav.blog') }}</a>
          <RouterLink to="/" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('footer.features') }}</RouterLink>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-white mb-4">{{ t('footer.legal') }}</h4>
          <RouterLink to="/terms" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('footer.termsConditions') }}</RouterLink>
          <RouterLink to="/privacy" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('footer.privacyPolicy') }}</RouterLink>
          <RouterLink to="/refund" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('footer.refundPolicy') }}</RouterLink>
        </div>
        <div>
          <h4 class="text-sm font-semibold text-white mb-4">{{ t('footer.support') }}</h4>
          <a href="mailto:namrastanov@gmail.com" class="block text-sm text-slate-400 no-underline mb-2.5 transition-colors duration-150 hover:text-white hover:no-underline">{{ t('footer.contactUs') }}</a>
        </div>
      </div>
    </div>

    <div class="max-w-[1200px] mx-auto pt-6 text-center">
      <p class="text-[13px] text-slate-500">&copy; {{ new Date().getFullYear() }} Code Board. {{ t('footer.rights') }}</p>
    </div>
  </footer>
</template>
